import store from "../../store";
import {httpReq} from "@/htttpReq";

export default {
  namespaced: true,

  state: {
    openModal: false,
    sets: {},
    packages: [],
    idToColor: '',
    setId: '',
    color: '',
    editPackages: [],
    width: '',
    drop: '',
  },

  getters: {
    packages(state) {
      return state.packages;
    },

    width(state) {
      return state.width;
    },

    drop(state) {
      return state.drop;
    },
  },

  mutations: {
    openModal(state, payload) {
      state.openModal = payload;
    },

    updateSets(state, payload) {
      state.sets = payload;
    },

    updatePackages(state, payload) {
      let d = _.reduce(payload, (result, value, key) => {
        let obj = {};
        obj.width = '';
        obj.drop = '';
        obj.id = value.id;
        obj.name = value.name;
        result[key] = obj;
        return result;
      }, {});
      state.packages = d;
    },

    updateWidthDrop(state, payload) {
      state.width = payload.width;
      state.drop = payload.drop;
    },

    editPackages(state, payload) {
      state.editPackages = [];
      _.forEach(payload, (item) => {
        state.editPackages.push(item);
      });
    },

    updateSetToColor(state, payload) {
      state.idToColor = payload;
    },

    updateSetId(state, payload) {
      state.setId = payload;
    },

    setColor(state, payload) {
      state.color = payload;
    }
  },

  actions: {
    getSets({commit}) {
      store.commit('preloader/preloader', true);
      httpReq.get('set/all-order-sets').then(response => {
        if (response) {
          commit('updateSets', response.data.data);
        }
      }).catch(error => {
        store.commit('errorsModal/openModal', error.response.data.errors);
      }).finally(() => {
        store.commit('preloader/preloader', false);
      })
    },

    postSet({state, commit}) {
      store.commit('preloader/preloader', true);
      httpReq.post('set/set-to-order', {

        order_id: parseFloat(store.getters['orderPreview/id']),
        set_id: state.setId,
        packages: state.editPackages,
        colour: state.color,
        location: store.state['createdOrder'].createdOrder.items.location,

      }).then(response => {
        if (response) {
          commit('updateSets', response.data.data);
          if(response.status === 200){
            store.dispatch('orderPreview/getPreview');
          }
        }
      }).catch(error => {
        store.commit('errorsModal/openModal', error.response.data.errors);
      }).finally(() => {
        store.commit('preloader/preloader', false);
      })
    }
  }
};
